
import React from 'react';

interface TimeDisplayProps {
  currentTime: number;
  duration: number;
  formatTime: (time: number) => string;
  color?: string;
  showDuration?: boolean;
}

export const TimeDisplay: React.FC<TimeDisplayProps> = ({
  currentTime,
  duration,
  formatTime,
  color = '#FFFFFF',
  showDuration = true,
}) => {
  return (
    <div className="text-sm ml-2" style={{ color }}>
      {formatTime(currentTime)}
      {showDuration && ` / ${formatTime(duration)}`}
    </div>
  );
};
